export enum ISOCountryCode {
  MY = "Malaysia",
  SG = "Singapore",
  TH = "Thailand",
  ID = "Indonesia"
}
